import React from 'react';
import { useTranslation } from 'react-i18next';
import './VideoProfileInput.scss';
import { Option } from '../../../common/interfaces';
import { Dropdown } from '../../FormComponents/Dropdown/Dropdown';
import { VideoProfileEnum } from '../../../types/enums/VideoProfileEnum';
import useProject from '../../../hooks/useProject';
import Help from '../../Help/Help';

const VideoProfileInput = () => {
  const { t } = useTranslation();
  const { updateEncoder, updateStream, project } = useProject();
  const options: Option[] = [];

  for (const key in VideoProfileEnum) {
    if (isNaN(Number(key))) {
      options.push({
        text: `${key}`,
        value: `${VideoProfileEnum[key as keyof typeof VideoProfileEnum]}`,
      });
    }
  }

  const onChange = (option: Option) => {
    if (project.encoder) {
      if (project.stream?.sourceLanguageIsoCode === project.encoder?.languageIsoCode) {
        updateStream({
          transcoderVideoProfile: parseInt(option.value),
        });
      } else {
        updateEncoder(project.encoder, {
          transcoderVideoProfile: parseInt(option.value),
        });
      }
    }
  };

  return (
    <div className="video-profile-input">
      <div className="input-title">
        {t('producer.inputs.video-profile.title')}
        <Help
          title="Video Profile"
          text="<b>Baseline:</b> Simplest profile, optimized for compatibility with most devices and lower-end hardware. Suitable for basic streaming needs.<br/><br/><b>Main:</b> Balanced profile offering better compression and quality than Baseline. Ideal for standard-definition to high-definition streams.<br/><br/><b>High:</b> Advanced profile providing the best compression and highest quality. Best for high-definition streams and professional applications, but may require more processing power."
        />
      </div>
      <Dropdown
        value={project.encoder.transcoderVideoProfile.toString()}
        options={options}
        onChange={onChange}
        placeholderKey="producer.inputs.video-profile.placeholder"
        readonly={false}
      />
      <div className="input-component-footer">{t('producer.inputs.video-profile.footer')}</div>
    </div>
  );
};

export default React.memo(VideoProfileInput);
